<div class="row">
    <div class="col-12">
        <myapp-loading></myapp-loading>
    </div>
</div>
